import { createSlice } from "@reduxjs/toolkit";

export const faculty = createSlice({
  name: "faculty",
  initialState: {
    value: {
      status: false,
      data: [] as { id: number; title: string }[],
    },
  },
  reducers: {
    update_faculty: (state, action) => {
      state.value.status = true;
      state.value.data = action?.payload?.data;
    },
    add_faculty: (state, action) => {
      const { id, title } = action?.payload;
      state.value.data = [...state.value.data, { id, title }];
    },
    remove_faculty: (state, action) => {
      const { id } = action?.payload;
      const currentArray = [...state.value.data];
      const currentIndex = currentArray.findIndex(
        (v: { id: number }) => Number(v.id) === id
      );
      currentArray.splice(currentIndex, 1);
      state.value.data = currentArray;
    },
    replace_faculty: (state, action) => {
      const { id, title, school_name } = action?.payload;
      const currentArray = state.value.data;
      const currentIndex = currentArray.findIndex(
        (v: { id: number }) => v.id === id
      );
      state.value.data = currentArray.splice(currentIndex, 1, {
        id,
        title,
      });
    },
    clear_faculty: (state) => {
      state.value.status = false;
      state.value.data = [];
    },
  },
});

export const {
  update_faculty,
  add_faculty,
  remove_faculty,
  replace_faculty,
  clear_faculty,
} = faculty.actions;

export default faculty.reducer;
